import { render, staticRenderFns } from "./SwitchToggle.vue?vue&type=template&id=1c4a628c&"
import script from "./SwitchToggle.vue?vue&type=script&lang=ts&"
export * from "./SwitchToggle.vue?vue&type=script&lang=ts&"
import style0 from "./SwitchToggle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports